export interface TagConfig {
  value: string[]
  enabled: boolean
}

export enum ShopSettingsCategory {
  SMART_TAG = 'smart_tag',
}

export interface ShopSettingResponse {
  excluded_tags: TagConfig
  vip_tag_enabled: boolean
  acquired_via_loyalty_tags: TagConfig
}

export interface ShopSettingsPayload {
  excluded_tags?: TagConfig
  vip_tag_enabled?: boolean
}
